const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'https://api.top-spin.ro'

// Inject preconnect hint at runtime so it works across all environments
const _preconnect = document.createElement('link');
_preconnect.rel = 'preconnect';
_preconnect.href = SERVER_URL;
document.head.appendChild(_preconnect);

const _dnsPrefetch = document.createElement('link');
_dnsPrefetch.rel = 'dns-prefetch';
_dnsPrefetch.href = SERVER_URL;
document.head.appendChild(_dnsPrefetch);

export { SERVER_URL };